module.exports = __webpack_public_path__ + "static/media/19ESCAP1.28555f0f.jpg";